import { render } from "./DeclareBudgetCheck.vue?vue&type=template&id=33a03ce3"
import script from "./DeclareBudgetCheck.vue?vue&type=script&lang=js"
export * from "./DeclareBudgetCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__